export default __webpack_public_path__ + "static/media/Img122.82531424.jpg";